/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Voltar",
      "<h3 class=”header-3”>Status de Acessibilidade</h3> <p>A Lei Europeia de Acessibilidade exige que projetemos nossos serviços de comércio eletrônico (incluindo métodos de identificação e pagamento) com acessibilidade em mente, para que sejam perceptíveis, operáveis, compreensíveis e robustos. Além disso, buscamos projetar nossos sites e aplicativos em conformidade com as <a href=\"https://www.w3.org/WAI/standards-guidelines/wcag/\" target=\"_blank\">Diretrizes de Acessibilidade para Conteúdo Web 2.1 do W3C, Nível AA</a>. Para atingir esses objetivos, fizemos o seguinte: </p> <ul> <li>Nos associamos a consultorias de acessibilidade como a Level Access para entender como podemos tornar nossos serviços mais acessíveis.</li> <li>Avaliamos nossas experiências digitais de acordo com os padrões globais de acessibilidade.</li> <li>Aprendemos com um time diverso de especialistas em acessibilidade, incluindo pessoas com deficiências e necessidades adicionais de acessibilidade.</li> </ul>",
      "<h3 class=”header-3”>Feedback e contato</h3> <p>Enquanto nos esforçamos para garantir a acessibilidade para todos os usuários, algumas limitações podem existir. Agradecemos seu feedback para nos ajudar a melhorar, então, se você encontrar barreiras de acessibilidade ou precisar de informações em um formato alternativo, entre em contato conosco em accessibility@bumble.com.</p>",
      "<h3 class=”header-3”>Melhorias Futuras</h3> <p>Nosso trabalho em acessibilidade continua. Continuaremos a:</p> <ul> <li>monitorar e avaliar a acessibilidade em todas as nossas plataformas digitais;</li> <li>corrigir problemas identificados e prevenir novas barreiras, integrando a acessibilidade desde a fase de projeto;</li> <li>fortalecer o treinamento interno e a conscientização para aprimorar as práticas de design inclusivo.</li> </ul>",
      "<h3 class=”header-3”>Atualizado em: novembro de 2025</h3>",
      "<h3 class=”header-3”>Medidas tomadas</h3> <p>Para alcançar os melhores padrões de acessibilidade em nossos serviços, nós:</p> <ul> <li>Firmamos parceria com a Level Access para realizar avaliações de acessibilidade completas.</li> <li>Integramos ferramentas de acessibilidade em nossas plataformas, como tecnologias assistivas como alternativa ao teclado, digitação por voz e navegação sem contato.</li> <li>Realizamos testes em colaboração com usuários com deficiência para coletar feedback concreto e identificar áreas de melhoria.</li> <li>Integramos fortemente os princípios de acessibilidade em nossos processos de desenvolvimento de produtos e garantia de qualidade.</li> <li>Estabelecemos um programa de acessibilidade digital para todas as equipes da empresa.</li> <li>Implementamos uma <a href=\"https://www.levelaccess.com/bumble/\" target=\"_blank\">plataforma de suporte acessível para clientes</a>. Este serviço é gratuito e está disponível para qualquer pessoa que tenha dificuldade para digitar, mover as mãos, usar um mouse ou ler. Inclui ferramentas como alternativas para mouse e teclado, reconhecimento de voz, digitação por voz, navegação sem contato/com as mãos e muito mais.</li></ul>",
      "<h3 class=”header-3”>Nossa Política</h3> <p>No Bumble, a justiça está no centro dos nossos valores. Para nós, não é apenas uma palavra da moda: nos esforçamos para tornar a experiência no Bumble acessível, justa e equitativa.</p> <p>Esta Declaração de Acessibilidade foi escrita para informar nossos usuários sobre a acessibilidade do nosso serviço e sua conformidade com os padrões legais e técnicos aplicáveis. Ela abrange os elementos dos nossos serviços [RS2] cobertos pela Lei Europeia de Acessibilidade, especificamente nossos serviços de comércio eletrônico, que permitem aos usuários acessar uma variedade de recursos aprimorados e premium do Bumble. Esses serviços são acessíveis pelo aplicativo do Bumble.</p>",
      "Declaração de Acessibilidade da Lei Europeia de Acessibilidade (EAA)",
      "Baixe na App Store",
      "Baixe no Google Play",
      "Carrossel",
      "Slide {{number}}",
      "Próximo slide",
      "Slide anterior",
      "Slide",
      "Slide {{number}} de {{total}}",
      "Não vender nem compartilhar as minhas informações pessoais",
      "Não vender nem compartilhar as minhas informações pessoais",
      "Envie Compliments no Bumble e chame a atenção de alguém antes mesmo de rolar conexão. Experimente agora",
      "Compliments | Como enviar um Compliment | Bumble",
      "Uma página personalizada que destaca as pessoas mais compatíveis com você, atualizada todos os dias.",
      "Descubra | Encontre pessoas compatíveis | Bumble",
      "Tenha encontros como você preferir e controle quem vê seu perfil do Bumble com o Modo Invisível. Saiba mais sobre como usar o Modo Invisível no Bumble em nosso guia",
      "Modo Invisível | Esconda Seu Perfil | Bumble",
      "Depois de ter uma conversa pessoalmente no Bumble, veja se rola uma química continuando a conversa no aplicativo.",
      "Conexão imediata | Mantenha a conversa no aplicativo | Bumble",
      "Precisa de uma pequena pausa ou de algum tempo para você? Descubra como pausar sua conta do Bumble com o Modo Não Perturbe do Bumble. Ele permite que você tenha encontros de acordo com seus próprios termos.",
      "Modo Não Perturbe | Pause Sua Conta | Bumble",
      "Acabou de ver alguém que você realmente curtiu no Bumble? Use um SuperSwipe para mostrar que você está falando sério. Toque na estrela do perfil para começar ou veja mais detalhes aqui",
      "Bumble SuperSwipe | O que é um SuperSwipe? | Bumble",
      "Viajando a trabalho ou a lazer? O Modo Viagem no Bumble pode te ajudar a fazer novas conexões divertidas em um novo lugar e ter encontros onde quer que você vá. Descubra o Modo Viagem aqui agora",
      "Modo Viagem do Bumble | Conheça Alguém em Qualquer Lugar | Bumble",
      "Quer saber se a conexão que você sente por meio das mensagens é igual na vida real? Experimente uma chamada por vídeo ou chamada de voz no Bumble e veja a vibe é boa.",
      "Chamada de vídeo | Faça uma chamada | Bumble",
      "Bumble Date",
      "Nossos apps",
      "Sobre",
      "Vagas",
      "Fale conosco",
      "Investidores",
      "Loja",
      "Empresa",
      "Baixe o app",
      "Acessibilidade no Bumble",
      "Regras",
      "Gerenciar cookies",
      "Lei sobre Escravatura Moderna",
      "Notificação de coleta de dados",
      "Política de privacidade",
      "Termos e Condições",
      "Jurídico",
      "Política de Privacidade da Washington Consumer Health",
      "Escaneie o QR code para baixar o app do Bumble",
      "Entrar",
      "Encerrar contratos aqui",
      "Baixe agora",
      "Escaneie o QR code para começar.",
      "Encontre sua próxima conexão",
      "Baixe o aplicativo",
      "Página inicial do Bumble",
      "Fechar menu",
      "Abrir menu",
      "Em Breve: Histórias de amor do Bumble",
      "Escolha seu idioma",
      "Selecionar idioma",
      "Rodapé",
      "Acessibilidade no Bumble",
      "A Apple e o logotipo da Apple são marcas comerciais da Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Vagas",
      "Eventos",
      "O Google Play é uma marca registrada da Google LLC.",
      "Regras",
      "Investidores",
      "Gerenciar Cookies",
      "Gerenciar Cookies",
      "Lei sobre Escravatura Moderna (Reino Unido)",
      "Notificação de coleta de dados",
      "Política de Privacidade",
      "Guias de encontros sazonais",
      "Termos e Condições",
      "App",
      "Política de privacidade de dados de saúde do consumidor de Washington",
      "Sobre",
      "Embaixadores",
      "Conheça pessoas e faça novas amizades",
      "Desenvolva sua rede profissional e impulsione sua carreira",
      "Encontre um relacionamento, algo casual ou alguém interessante no meio do caminho.",
      "O Buzz",
      "Saiba mais",
      "Viaje pelo mundo com o Modo Viagem",
      "Date",
      "Eventos",
      "Recursos",
      "Compliments",
      "Envie alguns Compliments e ganhe destaque na multidão.",
      "Descubra",
      "Uma página personalizada que destaca as pessoas mais compatíveis com você, atualizada todos os dias.",
      "Modo Invisível",
      "Esconda seu perfil de todo mundo com o Modo Invisível.",
      "Conexão imediata",
      "Iniciou uma conversa pessoalmente em um evento do Bumble? Continue no aplicativo.",
      "Modo Não Perturbe",
      "Reserve um momento para você com o Modo Não Perturbe. Quando quiser voltar, você sabe onde nos encontrar.",
      "SuperSwipe",
      "Curtiu o perfil de alguém? Mostre enviando um SuperSwipe.",
      "Modo Viagem",
      "Encontre sua felicidade em qualquer lugar do mundo graças ao Modo Viagem.",
      "Chamadas de vídeo",
      "Use chamadas de vídeo e áudio para verificar se você está pronto para se encontrar pessoalmente.",
      "Baixar o app do Bumble",
      "BFF",
      "Segurança",
      "Histórias",
      "Suporte",
      "Loja",
      "Principal",
      "Envie alguns Compliments e ganhe destaque.",
      "Compliments",
      "Recursos projetados para criar espaço para conexões reais, respeitosas e de verdade.",
      "Esconda seu perfil de chefes, de entes queridos ou de ex.",
      "Modo Invisível",
      "Reserve um momento para você com o Modo Não Perturbe.",
      "Modo Não Perturbe",
      "Curtiu alguém? Deixe claro!",
      "SuperSwipe",
      "Explorar os Date",
      "Conheça pessoas do mundo todo.",
      "Modo Viagem",
      "Chegue o mais perto possível da vida real sem sair de casa.",
      "Chamadas de vídeo",
      "Ative a experiência do Bumble diretamente do seu navegador.",
      "Aplicativo Web",
      "Nossos líderes ajudam a trazer os valores do Bumble para suas comunidades em todo o país.",
      "Líderes da Comunidade",
      "Recursos projetados para ajudar você a encontrar pessoas com ideias semelhantes e se conectar com outras com base em seus pontos em comum.",
      "Organize um encontro em grupo, ou descubra eventos locais acontecendo nas proximidades.",
      "Planos",
      "Explorar o BFF",
      "Toda a orientação e inspiração que você precisa para te ajudar a encontrar amor e amizade.",
      "Conselhos e histórias para ajudar a construir as amizades que você deseja.",
      "Centro de Amizade",
      "De Tóquio a Toronto, explore o amor encontrado no Bumble ao redor do mundo.",
      "Histórias de Amor",
      "Planeje o encontro perfeito, não importa quando, onde ou com quem você esteja saindo.",
      "Guias de encontros sazonais",
      "Explorar Histórias",
      "Ir para o conteúdo principal",
      "Logo do Bumble",
      "Fechar menu de navegação",
      "Abrir menu de navegação",
      "Retrato de Whitney Wolfe Herd, fundadora e CEO do Bumble",
      "A Whitney Wolfe Herd fundou o Bumble com um objetivo: construir o espaço mais confiável para encontrar o amor, baseado no respeito e onde as mulheres dão o primeiro passo.{{__EOL__}}{{__EOL__}}Como CEO, ela continua a liderar a empresa com a mesma convicção: para encontrar o amor online, precisamos de segurança e autenticidade. Muito mais do que um site de relacionamento, o Bumble ajuda seus membros a encontrar o que mais importa: amor-próprio, intenção e gentileza. Usamos tecnologia e IA para aprofundar a conexão humana, não para substituí-la. Usamos tudo o que aprendemos — o bom e o imperfeito, e com honestidade — para fazer com que nossa comunidade se sinta sempre bem-vinda no Bumble.",
      "Whitney Wolfe Herd",
      "Casal sorridente se inclinando para um beijo e de mãos dadas no banco de trás de um carro, com vegetação ao fundo.",
      "Acreditamos que o amor—em todas as suas formas—é a base de uma vida feliz e saudável.",
      "Olá. Somos a Empresa do amor.",
      "Tela de conexões do Bumble com dois perfis e uma dica para iniciar a conversa.",
      "O resultado? Um lugar feito para criar conexões gentis e saudáveis com seus membros.",
      "Em {{date}}, reescrevemos as regras de relacionamentos.",
      "Nossa missão: ajudar você a (re)descobrir o amor.",
      "Nossa Missão",
      "Estamos revolucionando os relacionamentos: agora as mulheres dão o primeiro passo.",
      "O Bumble acaba de nascer!",
      "Porque o amor pode assumir muitas formas, estamos lançando o {{bff}} para criar novas amizades.",
      "Além dos relacionamentos",
      "A Serena Williams está nos ajudando a mostrar no Super Bowl que as mulheres podem dar o primeiro passo.",
      "Nossa estreia no Super Bowl",
      "Estamos lançando novos recursos para facilitar os encontros durante a pandemia do Covid-19.",
      "Os encontros se tornaram virtuais",
      "Somos a primeira empresa liderada por mulheres a abrir o capital.",
      "A história está sendo escrita",
      "Estamos expandindo nossas políticas de proteção às mulheres, além de nossa tecnologia anti-cyberflashing",
      "Maior segurança",
      "Damos ao esporte feminino o lugar que ele merece.",
      "NBA feminina x Bumble",
      "Estamos contribuindo para um futuro que é possível acreditar no amor.",
      "Liderando com amor",
      "Começamos com um movimento ousado. Estamos construindo o lugar mais seguro e eficaz para encontrar o amor.",
      "Deslize para explorar",
      "Deslize para a esquerda",
      "Deslize para a direita",
      "Nossa História",
      "Veja nossas vagas abertas",
      "Ajude a construir um lugar mais seguro para encontrar o amor.",
      "Trabalhe conosco",
      "Telas do aplicativo BFF destacando a visualização do perfil do membro e os interesses para se conectar com amigos",
      "Se você acabou de chegar em uma nova cidade ou está procurando fazer novas amizades, o {{bff}} ajuda você a conhecer pessoas compatíveis facilmente.",
      "Encontrar a minha tribo",
      "Colagem de perfis do Bumble mostrando pessoas diversas com selo de identificação verificados, incluindo uma mulher tirando uma selfie em frente ao espelho.",
      "Não importa se você está dando os primeiros passos em relacionamentos ou quer voltar a eles, o Modo Date do Bumble foi criado para ajudar você a (re)descobrir o amor de uma forma sincera e segura.",
      "Encontre sua conexão",
      "Mulher sorridente em um parque com um skate na mão",
      "Lugares abertos",
      "Homem correndo e sorrindo em um parque urbano",
      "Corrida",
      "Mulher segurando um cachorrinho peludo ao ar livre",
      "Pai/Mãe de cães",
      "Baixar Bumble",
      "Queremos que nossos membros encontrem relacionamentos significativos e autênticos que despertem confiança e alegria.",
      "Estamos aqui para aproximar as pessoas do amor.",
      "Mulher com cabelos escuros presos em um longo rabo de cavalo, vestindo uma regata preta e óculos de sol, sorrindo com o mar atrás dela.",
      "Homem barbudo vestindo uma camisa listrada, segurando uma câmera e em pé ao ar livre com árvores e prédios ao fundo.",
      "Mulher vestindo uma jaqueta vermelha com listras de arco-íris, fones de ouvido prateados e um colar com estrelas verdes, olhando para a câmera.",
      "Casal sorridente se abraçando em um retrato em preto e branco",
      "{{name1}} e {{name2}}, casados em {{num}}",
      "Saiba mais",
      "Ler mais histórias",
      "\"{{__EOL__}}Somos pessoas naturalmente positivas e otimistas. Quando estamos juntos, sentimos que nada pode nos parar.\"",
      "Duas pessoas rindo em uma quadra de tênis; uma delas cobre os olhos com bolas de tênis",
      "Encontrar pessoalmente",
      "Desligue as telas e comece a conversar pessoalmente nos eventos do Bumble. Com alguém ou sem alguém: venha como quiser... e volte para casa com uma nova conexão.",
      "Inicie a conversa pessoalmente",
      "Pessoas desfrutando de conexões no Bumble através de fotos, chamadas de vídeo e conselhos de especialistas.",
      "Cadastrar",
      "Ajude a moldar o futuro do Bumble juntando-se ao nosso Círculo de Membros. Esta comunidade seleta de membros compartilha ideias diretamente com nossa equipe por meio de conversas, discussões e testes de produto.{{__EOL__}}{{__EOL__}}Os participantes terão acesso antecipado a novos recursos, uma prévia das próximas campanhas e a oportunidade de contribuir para tornar o Bumble ainda melhor para todos.",
      "Compartilhe suas ideias",
      "Quer conhecer alguém melhor? Use a chamada de vídeo no Bumble",
      "Basta tocar no ícone de vídeo na sua conversa para iniciar uma chamada de vídeo, tudo sem compartilhar nenhuma informação pessoal de contato.",
      "Como funciona a chamada de vídeo no Bumble?",
      "Não. Todas as chamadas e conversas no Bumble mantêm suas informações pessoais seguras e protegidas. Ninguém receberá seu número ou quaisquer outros dados de contato até que você os informe.",
      "Minha conexão consegue ver meu número de telefone?",
      "Absolutamente! Se você ainda não estiver pronto para um encontro cara a cara, as chamadas de voz permitem que você se conecte por meio de áudio. Basta selecionar o ícone de chamada.",
      "Posso tentar uma chamada de áudio?",
      "Adoramos aquela notificação de *mensagem recebida*. Mas sabemos que é difícil dizer se suas conversas serão tão boas ou não pessoalmente. É aí que entram as chamadas de vídeo e de áudio.",
      "Chamada de vídeo no Bumble",
      "<a href={{video_chat_url}}>Chamadas de vídeo e chamadas de áudio</a> podem ajudar vocês a se conhecerem e a decidir se desejam retirar coisas do aplicativo. A melhor parte? Ao fazer uma chamada via Bumble, você não precisa trocar números de telefone – portanto, suas informações pessoais permanecem seguras até que você queira compartilhá-las.",
      "Verifique sua química com a chamada de vídeo.",
      "Feche a lacuna entre o relacionamento online e offline e decida se agora é a hora de se encontrar.",
      "Conheça alguém melhor (e mais rápido). Uma conversa cara a cara ou uma ligação podem revelar muito sobre uma conexão.",
      "Você está no controle. Manteremos seus dados de contato privados, para que você possa escolher quando compartilhá-los.",
      "Veja se está na hora de se encontrar pessoalmente",
      "Veja se rola uma química",
      "Conectar sem fornecer dados pessoais",
      "Por que você deveria usar chamadas de vídeo e áudio",
      "Tudo pronto para iniciar uma conversa? Você pode escolher se deseja iniciar uma chamada de áudio ou vídeo diretamente das suas conversas no aplicativo do Bumble. Para iniciar uma chamada de vídeo, toque no ícone cinza da câmera de vídeo no canto superior direito. Você também verá três pontos ao lado do ícone, clique nele e verá a opção de chamada de áudio também.",
      "Como fazer chamadas de vídeo",
      "Tudo pronto para ativar o Compliments?",
      "Quando você envia um Compliment, a pessoa que o recebe vai te ver quando você aparecer na lista de conexões dela.",
      "O que acontece quando você envia um Compliment a alguém no Bumble?",
      "Se o Compliments de alguém chamou sua atenção, vá em frente e combine com eles. Você verá o Compliments em suas conversas e as regras usuais de dar o <a href={{make_the_first_move_url}}>Primeiro Passo</a> se aplicam.",
      "Como posso responder a um Compliment?",
      "Você pode enviar {{num}} [[Compliments:num]] de graça. Quando você estiver sem Compliments, poderá comprar mais no aplicativo do Bumble em pacotes de até 30. Um deles será usado para enviar esse Compliment (salve o restante para quando você ver outro perfil que goste). Não se preocupe, não tem validade!",
      "Quantos Compliments posso enviar?",
      "Uma palavra gentil (ou duas) pode ajudar muito. Se você deseja enviar um Compliment, mas não sabe por onde começar, tente estes para se inspirar:",
      "Ver mais exemplos",
      "“Qualquer pessoa que aprecie [nome do artista], tem um ótimo gosto.”",
      "\"Seu sorriso é contagiante!\"",
      "“Seu perfil me fez rir. Muito bom!”",
      "Como enviar os melhores Compliments no Bumble",
      "Quer fazer alegrar o dia de alguém? Parece que está tudo pronto para usar o Compliments.",
      "Compliments no Bumble",
      "Use Compliments no Bumble para que essa pessoa saiba que você gosta do perfil dela. Você recebe Compliments como parte da sua assinatura do {{service_level_lexeme_name}}. É também uma forma de enviar e receber mensagens antes mesmo de rolar conexão.",
      "Como o Compliments funciona",
      "Quando você receber um Compliment, ele aparecerá no perfil do remetente. Você também receberá uma notificação informando que alguém gostou de parte do seu perfil.",
      "Veja seus compliments",
      "Você pode enviar um Compliment tocando no ícone de coração amarelo na parte inferior do perfil de alguém. Onde você toca é importante, porque você estará elogiando aquela foto específica ou parte do perfil deles! Ao clicar, uma caixa de texto será aberta para você escrever sua mensagem (pode ter até 150 caracteres).",
      "Envie um compliment",
      "BAIXE O Bumble E ATIVE O DESCUBRA AGORA",
      "Todos os dias, a partir das 9 horas da manhã, você verá novas pessoas para você no Descubra. Você pode se conectar com elas pelas coisas que vocês têm em comum.",
      "Quando o Descubra atualiza?",
      "Sua página Descubra classifica possíveis conexões em 3 categorias principais: interesses semelhantes, mesmos objetivos de encontro e comunidades em comum. Recomendações de perfil também são mostradas, com base em conexões anteriores.",
      "Como minha página Descubra é selecionada?",
      "Uma página personalizada que destaca as pessoas mais compatíveis com você, atualizada todos os dias",
      "ENCONTRE PESSOAS QUE ESTÃO NA MESMA VIBE QUE VOCÊ COM {{qr_code}} O DESCUBRA",
      "Com o Descubra você recebe uma seleção de pessoas que achamos que você gostará, com base em seus interesses semelhantes, objetivos de relacionamento e comunidades.",
      "Experimente o Descubra",
      "QUER UMA NOVA MANEIRA DE ENCONTRAR COISAS EM COMUM?",
      "A página Descubra se renova a cada dia para mostrar ainda mais pessoas compatíveis com você. Assim, você pode gastar menos tempo esperando por uma conexão e mais tempo conhecendo pessoas de quem certamente gostará.",
      "TODOS OS DIAS NOVAS RECOMENDAÇÕES",
      "As recomendações do Descubra são baseadas no seu perfil e com quem já rolou uma conexão anteriormente. Com isso, você verá pessoas que curtam e queiram o mesmo que você, seja um simples rolinho à primavera ou até mesmo um relacionamento longo.",
      "PERSONALIZADO{{__EOL__}}SÓ PARA VOCÊ",
      "Baixar Bumble",
      "Perguntas Frequentes",
      "Tudo pronto para navegar pelo Bumble de forma privada?",
      "Ao ativar o Modo Invisível, você não aparecerá para outros membros do Bumble a menos que curta o perfil deles.",
      "Como funciona o Modo Invisível?",
      "Sem o Modo Invisível, seu perfil é visível a outros membros no Bumble quando você se encaixa em suas preferências, como idade e localização. Quando você ativa o Modo Invisível, as pessoas só verão você depois que você curtir o perfil delas.",
      "Quem pode me ver no Modo Invisível do Bumble?",
      "Usar o modo de navegação anônima não é o mesmo que <a href={{blocking_on_bumble_url}}>bloquear alguém no Bumble</a>. Com esse recurso, se você curtir alguém (ou se já tiver enviado mensagens para essa pessoa), essa pessoa poderá ver seu perfil.",
      "O Modo Invisível é como bloquear alguém?",
      "Tenha mais controle sobre quem vê seu perfil com o Modo Invisível do Bumble.",
      "Modo Invisível no Bumble",
      "Se quiser dar um passo para trás dos relacionamentos ou navegar no Bumble sem que outros relacionamentos anteriores vejam seu perfil, você pode alternar para o Modo Invisível. Ativar esse recurso significa que ocultaremos você de todos, a menos que você curta alguém primeiro. Ele permite que você controle o que você compartilha e quem vê você.",
      "Esconda seu perfil usando o Modo Invisível",
      "Você decide quem pode ver suas fotos e informações pessoais.",
      "Quer incluir algo pessoal em seu perfil? Você pode compartilhar discretamente o que desejar com suas conexões atuais.",
      "Navegue livremente sem se preocupar em encontrar um antigo relacionamento, alguém do trabalho ou qualquer outra pessoa que não esteja no seu radar.",
      "Assuma o controle total",
      "Escolha o que você quer compartilhar",
      "Evite encontros desconfortáveis",
      "Por que você vai amar o Modo Invisível",
      "O Modo Invisível está disponível para membros do {{service_level_lexeme_name}} e do {{service_level_lexeme_name_two}}. Após se inscrever, você pode ativá-lo acessando a guia do seu Perfil, tocando em Configurações no canto superior direito e alterando para Modo Invisível.",
      "Ative o {{service_level_lexeme_name}}",
      "Como usar o Modo Invisível no Bumble",
      "BAIXE O Bumble E EXPERIMENTE UMA CONEXÃO IMEDIATA HOJE",
      "No aplicativo do Bumble, acesse o ícone do Perfil na parte inferior da tela. A partir daí, você encontrará o ícone do QR code no canto superior direito da tela. Toque nele para acessá-lo.",
      "Onde posso encontrar o meu QR code pessoal?",
      "Não! Você precisa estar conectado à internet, seja por meio de dados móveis ou Wi-Fi, e usar o QR code atual e ativo para que a Conexão imediata funcione.",
      "Posso fazer uma captura de tela do meu QR code para compartilhar?",
      "Não! Se uma pessoa escanear o código, a conexão será automática.",
      "Ambas as pessoas precisam escanear o QR code?",
      "Com a Conexão imediata, você pode ver automaticamente o que você e sua nova conexão têm em comum. Isso te dá desde o início uma visão geral no nível de compatibilidade entre vocês.",
      "ENCONTRE O QUE VOCÊ TEM EM COMUM, DESDE O INÍCIO",
      "Iniciou uma conversa pessoalmente em um evento do Bumble? Continue no aplicativo.",
      "TRANSFORME SUA REUNIÃO EM UMA CONEXÃO IMEDIATA {{qr_code}}",
      "A Conexão imediata, facilita a transição do primeiro encontro até a continuação da conversa, sem a necessidade de troca de números ou perfis sociais. Você só precisa digitalizar seu QR code para rolar uma conexão no Bumble.",
      "Experimente uma Conexão imediata",
      "CONHECEU ALGUÉM EM UM EVENTO DO Bumble PESSOALMENTE?",
      "Em vez de compartilhar sua mídia social ou número de telefone, a Conexão imediata permite que você verifique primeiro sua química no aplicativo. Assim, vocês podem se conhecer no seu próprio ritmo, graças aos recursos de segurança do Bumble.",
      "UMA MANEIRA MAIS SEGURA DE SE CONECTAR",
      "Depois de ter uma conversa pessoalmente no Bumble, veja se rola uma química \n continuando a conversa no aplicativo e descubra quais interesses vocês têm em comum, seja a paixão por café coado ou drinks exóticos.",
      "NÃO DEIXE A CONVERSA PARAR",
      "Quer fazer uma pausa? Experimente o Modo Não Perturbe",
      "Sim, você pode mudar suas configurações ou sua fila e desativar o Não Perturbe sempre que quiser.",
      "Posso desativar o Modo Não Perturbe antes do tempo?",
      "Vá para configurações, toque em Não Perturbe e escolha quanto tempo deseja ficar ausente. Volte sempre que se sentir quiser.",
      "Como uso o Modo Não Perturbe no meu perfil?",
      "Não, enquanto estiver no Modo Não Perturbe, todas as atividades de deslizar e conversar serão pausadas. Ao visitar novas pessoas, você verá uma mensagem informando quanto tempo o Modo Não Perturbe durará, com a opção de desativá-lo.",
      "Posso ver perfis e ainda conversar no Modo Não Perturbe?",
      "As pessoas para quem você já enviou mensagens verão seu status ‘Ausente’ (se você decidir definir um). Caso contrário, eles verão suas mensagens anteriores na caixa de entrada normalmente.",
      "O que minhas conexões verão quando eu estiver no Modo Não Perturbe?",
      "Você tem controle total sobre a atividade do Bumble e pode sair da plataforma sempre que quiser.",
      "Você pode manter as conexões existentes atualizadas usando sua atualização de status, para que não pareça que você <a href={{ghosted_article_url}}>deu um perdido em alguém</a>. Além disso, é tudo automatizado – então você não precisa enviar nenhuma mensagem.",
      "Faça uma pausa nos encontros ativos sem perder suas conexões ou conversas.",
      "Conheça alguém (ou dê um tempo) de acordo com suas preferências",
      "Mantenha suas conexões atualizadas",
      "Pause sua atividade, mas não suas conexões",
      "Por que amamos o Modo Não Perturbe",
      "Abra o aplicativo do Bumble, acesse o guia do seu perfil e toque na engrenagem de configurações no canto superior direito. Nas configurações, toque em Não Perturbe e escolha por quanto tempo você ficará ausente. Você pode ocultar seu perfil por 24 horas, 72 horas, uma semana ou indefinidamente.{{__EOL__}}{{__EOL__}}Lembre-se: conexões sem conversas ativas expirarão enquanto você estiver no Modo Não Perturbe. Se você decidir definir um status, as pessoas com quem você está conversando no momento poderão ver que você está ausente.",
      "Como o Modo Não Perturbe funciona no Bumble",
      "Quando a vida fica agitada, o Modo Não Perturbe está aqui para ajudar. Pause sua conta do Bumble e tenha encontros de acordo com seus próprios termos.",
      "Modo Não Perturbe no Bumble",
      "O Modo Não Perturbe é uma maneira fácil de pausar sua conta quando você quiser dar uma pausa nos encontros. Você ainda pode conversar com suas conexões existentes, esse modo apenas ocultará seu perfil de outras pessoas até que você esteja afim para começar se relacionar novamente. Você não perderá as informações do seu perfil nem excluirá conexões existentes ativando o Modo Não Perturbe.",
      "Ative o Modo Não Pertube no Bumble",
      "Enquanto estiver no Modo Não Perturbe, você pode optar por informar às conexões existentes que está fazendo uma pausa com uma atualização de status. Escolha entre 'Estou viajando', 'Estou focado no trabalho', 'Estou em uma desintoxicação digital' ou 'Estou me priorizando'. Seja qual for a sua vibe, estamos nessa com você.",
      "Adicione um status \"Ausente\"",
      "A ativação do Modo Não Perturbe pausa sua conta do \n Bumble (ou {{page_partner_name_bff}}). Suas conexões não saberão que você está no Modo Não Perturbe, a menos que você diga a elas. Se você decidir sair do Modo Não Perturbe antes do período escolhido inicialmente, basta retornar às configurações e tocar em “desativar Modo Não Pertube\". Simples assim.",
      "Pausar suas conversas",
      "Ative o SuperSwipe no Bumble",
      "Quantos você quiser! Os membros do {{service_level_lexeme_name}} recebem {{num}} [[superswipe:num]] toda semana, mas você pode recarregar seu saldo a qualquer momento. Membros gratuitos podem comprar pacotes de SuperSwipes.",
      "Quantos SuperSwipes eu posso enviar no Bumble?",
      "Depois que alguém usar um SuperSwipe em seu perfil, você será receberá uma notificação imediatamente. Você também verá um rótulo acima do nome dessa pessoa em seu perfil, informando que ela gosta de você.",
      "Como faço para saber se alguém me deu um SuperSwipe?",
      "Está curtindo alguém de verdade? Existe uma maneira legal de quebrar o gelo. Basta enviar um SuperSwipe para que essa pessoa saiba que você gosta dela e tenha ótimas  conversas mais rápido.",
      "SuperSwipe no Bumble",
      "Ter destaque nem sempre é fácil, mas o SuperSwipe pode ajudar você a causar uma ótima primeira impressão.{{__EOL__}}{{__EOL__}}Quando você usa um SuperSwipe, uma notificação será enviada para a pessoa de quem você gostou. Você então pulará para o início da fila com um rótulo em seu perfil. Se gostarem de você também, é hora de começar a conversar.",
      "O que é um SuperSwipe?",
      "Ousar e se destacar",
      "Começar mais conversas",
      "Fazer mais conexões",
      "SuperSwipe te ajudar...",
      "Se você tem <a href={{bumble_boost_url}}>Bumble {{service_level_lexeme_name}}</a> ou Bumble {{service_level_lexeme_name_one}}, você ganha {{num}} [[superswipe:num]] grátis por semana. Além disso, todos os membros podem comprar pacotes de até {{num_two}} [[superswipe:num_two]] na guia do perfil. Se você tiver {{service_level_lexeme_name_three}}, receberá {{num_three}} [[superswipe:num_three]] por semana{{__EOL__}}{{__EOL__}}Usar o SuperSwipe é simples: quando você vir alguém de quem gosta, basta tocar no ícone de estrela amarela na parte inferior do perfil.",
      "Como usar o SuperSwipe",
      "Conheça alguém com o Modo Viagem do Bumble",
      "<a href={{bumble_premium_url}}>membros do {{service_level_lexeme_name}}</a> podem usar o Modo Viagem. Ative agora e a sua fila mostrará novas pessoas no seu destino escolhido.",
      "Como posso usar o Modo Viagem?",
      "Basicamente, temos algumas restrições de segurança que podem mudar com o tempo, mas o Modo Viagem está disponível para a maioria dos destinos.",
      "Posso usar o Modo Viagem em qualquer lugar?",
      "O Modo Viagem mostrará sua localização como o centro da cidade escolhida, para que novas conexões na área possam te encontrar. As pessoas poderão ver uma nota em seu perfil informando que você está no Modo Viagem, para que saibam que você está visitando ou planejando visitar.",
      "Fazendo as malas para as férias ou indo para uma nova cidade a trabalho? Ative o Modo Viagem do Bumble e tenha encontros para onde for.",
      "Modo Viagem no Bumble",
      "O Modo Viagem é a melhor ferramenta para fazer conexões enquanto você estiver ausente. Defina sua localização para qualquer lugar do mundo e seu perfil aparecerá na cidade que você escolher. Isso significa que você pode começar um relacionamento onde quer que suas aventuras te levem.",
      "O que é Modo Viagem?",
      "Ninguém conhece um lugar melhor do que os habitantes locais. O Modo Viagem pode te ajudar a se conectar com pessoas que tornarão sua viagem ainda mais especial.",
      "Defina a sua localização para a cidade até sete dias antes de ir, para que você possa planejar encontros e encontrar conexões antes de chegar ao seu destino.",
      "Pense além de apenas viagens à praia: você pode estar em casa durante as férias, viajando a trabalho ou explorando uma nova cidade. Encontre o amor onde quer que você vá.",
      "Escolha os melhores pontos de encontro locais",
      "Tenha uma aventura",
      "Faça conexões duradoras",
      "Motivos para amar o Modo Viagem",
      "O Modo Viagem está disponível para membros <a href={{bumble_premium_url}}>{{service_level_lexeme_name}} e {{service_level_lexeme_name_two}} </a> no Bumble. Toque na engrenagem Configurações no canto superior direito do seu perfil e role até ver o Modo Viagem. Escolha seu novo local para começar a ver pessoas nessa área. Seu perfil permitirá que potenciais parceiros saibam que você está no Modo Viagem.",
      "Como funciona o Modo Viagem?",
      "Testar agora",
      "Aqui ser gentil é irresistível, todo mundo é perfeito do jeito que é e as mulheres vêm em primeiro lugar, sempre.",
      "É aqui que se Dá o Primeiro Passo™",
      "Relacionamentos saudáveis ​​contribuem para uma vida produtiva e positiva. O Bumble permite que você faça conexões das maneiras mais gratificantes, seja por meio de encontros, amizades ou oportunidades de carreira.",
      "O diferencial do Bumble",
      "Defendemos integridade, gentileza, igualdade, confiança e respeito em todas as fases de um relacionamento. Celebramos todas as orientações, quer você esteja aqui para encontrar o amor ou apenas para se divertir.",
      "Os valores do Bumble",
      "No Bumble são as mulheres que dão o Primeiro Passo ou escolhem uma Mensagem inicial para que as conexões possam responder. Decidimos sacudir o mundo do encontros e colocar a igualdade em primeiro lugar.",
      "Como o Bumble funciona",
      "Sobre nós",
      "Baixe agora",
      "É melhor no aplicativo.",
      "Recursos que tornam sua vida online muito mais agradável",
      "12 de fevereiro, 2024",
      "Como aumentar a intimidade emocional em um relacionamento",
      "25 de janeiro, 2024",
      "Como usar o Bumble quando você nunca usou um aplicativo de relacionamento antes",
      "5 de fevereiro, 2024",
      "Deception Detector™",
      "Todas as últimas notícias do mundo do encontros",
      "Reserve um momento para você com o <b>Modo Não Perturbe</b>. Quando quiser voltar, você sabe onde nos encontrar.",
      "Faça uma pausa",
      "Use as <b>chamadas de vídeo</b> e as <b>chamadas de áudio</b> para se aproximar das suas conexões sem sair do casa.",
      "Diga em voz alta",
      "Ver mais",
      "Escolha um <b>Opening Moves</b> para convidar sua conexão para iniciar uma conversa, para que você não precise fazer isso.",
      "Menos esforço, mais conexões",
      "Encontre sua felicidade em qualquer lugar do mundo graças ao <b>Modo Viagem</b>.",
      "Para onde vamos?",
      "Curtiu o perfil de alguém? Mostre enviando um <b>SuperSwipe</b>.",
      "Chame a atenção de alguém",
      "Ganhe destaque na multidão com <b>Compliments</b>.",
      "Dê um sorriso",
      "Esconda seu perfil de todo mundo com o <b>Modo Invisível</b>.",
      "Fique invisível",
      "Conheça pessoas do seu jeito",
      "Alguns meses depois, ela também conheceu uma de suas madrinhas lá",
      "Hannah conheceu seu atual marido no Bumble.",
      "Antes de construirem sua casa juntos, Carène e You-Liang se conheceram no Bumble, onde as fotos de viagem de Carène chamaram a atenção de You-Liang.",
      "Carène e You-Liang",
      "Breno e Karen trabalharam juntos no exterior, mas se conheceram no Bumble",
      "Breno e Karen",
      "Se funcionou para alguém, pode funcionar para você",
      "Dê o próximo passo",
      "Veja o que há de novo",
      "Você merece o melhor, por isso criamos ótimas maneiras para você namorar mais e se estressar menos.",
      "Pra que se contentar quando você pode ter mais?",
      "Sobre o Bumble",
      "Somos o único aplicativo que torna os encontros melhores, colocando as experiências das mulheres em primeiro lugar. Porque quando as coisas melhoram para as mulheres, as coisas melhoram para todos.",
      "Make the first move™",
      "Encontre alguém que você curta e dê o primeiro passo. Crie conexões genuínas, discuta interesses comuns e, acima de tudo, divirta-se.",
      "Encontre alguém com o Bumble Date",
      "Encontre amizades para te ajudar a progredir em sua carreira. Conecte-se com outros profissionais para encontrar seu próximo emprego, uma mentoria ou até mesmo uma nova carreira.",
      "Faça mudanças na carreira com o Bumble Bizz",
      "Conheça alguém que se pareça com você. Faça amizades e encontre atividades para fazerem juntos, na sua cidade ou no exterior.",
      "Encontre novas amizades com o Bumble For Friends",
      "Somos muito mais do que encontros",
      "O Bumble é o aplicativo de relacionamento onde as mulheres dão o primeiro passo. É o aplicativo que mudou a maneira como as pessoas se relacionam, criam conexões verdadeiras e fazem networking. Baixe agora.",
      "Bumble no {{social_network}}",
      "Saber mais",
      "Baixe o Bumble na App Store ou no Google Play e faça login com a mesma conta que você usa no site do Bumble.{{__EOL__}}{{__EOL__}}Escaneie o código QR abaixo com seu celular ou tablet para começar.{{__EOL__}}{{__EOL__}}Suas conexões e conversas estão te esperando no aplicativo. 💛",
      "Baixe o aplicativo",
      "Para continuar oferecendo a melhor experiência e os melhores recursos de segurança, o Bumble agora está disponível apenas no aplicativo.",
      "O Bumble agora está disponível apenas por aplicativo.",
      "Não perca uma conexão",
      "Ligue sem informar seu número",
      "Confie que suas conexões são verdadeiras",
      "Receba notificações em tempo real para nunca perder uma mensagem.",
      "Use chamadas de voz e vídeo no aplicativo para saber mais, com segurança e privacidade.",
      "Converse com segurança com membros verificados por meio de verificação fácil de foto e identidade no aplicativo.",
      "Por que trocar para o aplicativo do Bumble?",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life",
      "Premium+",
      "Página não encontrada.",
      "Contato",
      "Ops, algo deu errado!",
      "(abre em nova janela)",
      "FAQ",
      "Política de Cookies",
      "Premium",
      "Blog do Bumble",
      "Vagas",
      "Conversas",
      "Cidades",
      "Gerenciar cookies",
      "Copyright © 2006 – presente. Bumble. Todos os direitos reservados.",
      "Relatório de Encontros com Confiança",
      "Apple e o logotipo da Apple são marcas comerciais da Apple Inc.{{__EOL__}}Google Play é uma marca registrada da Google LLC.",
      "Baixe o app",
      "Facebook",
      "Siga-nos",
      "Central de Ajuda",
      "Instagram",
      "Idioma",
      "LinkedIn",
      "O Bumble faz parte da Bumble Inc.",
      "Política de privacidade",
      "Safety Centre",
      "Mapa do site",
      "Declaração da Lei Modern Slavery Act",
      "Termos e condições",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "Compliments": {
            "plural": [
                  "interações"
            ],
            "singular": [
                  "interação"
            ]
      },
      "day": {
            "plural": [
                  "dias"
            ],
            "singular": [
                  "dia"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mês"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "superswipe": {
            "plural": [
                  "SuperSwipes"
            ],
            "singular": [
                  "SuperSwipe"
            ]
      },
      "year": {
            "plural": [
                  "anos"
            ],
            "singular": [
                  "ano"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
